import {Component, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TieredMenu} from 'primeng/tieredmenu';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'si-bar-menu',
  templateUrl: './bar-menu.component.html',
  styleUrls: ['./bar-menu.component.scss']
})
export class BarMenuComponent implements OnInit {
  items: MenuItem[];
  @ViewChild(TieredMenu) tieredMenu: TieredMenu;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.setItems();
  }

  async setItems(): Promise<void> {
    const homeText = await this.translateService.get('SI_HOME').toPromise();
    const mockModuleText = this.translateService.instant('SI_MOCK_MODULE');
    const mockComponentText = this.translateService.instant('SI_MOCK_COMPONENT');

    this.items = [
      {
        label: homeText,
        icon: 'icon-home',
        routerLink: '/',
        command: () => this.closeMenu()
      },
      {
        label: mockModuleText,
        icon: 'icon-viewheadline',
        items: [
          {label: mockComponentText, icon: '', routerLink: '/mock-module/mock-list', command: () => this.closeMenu()}
        ]
      },
      {
        label: 'Core components',
        icon: 'icon-book',
        items: [
          {label: 'Core', icon: '', routerLink: '/core/documentation', command: () => this.closeMenu()}
        ]
      }
    ];
  }

  closeMenu(): void {
    this.tieredMenu.hide();
  }
}
